import { createContext, PropsWithChildren, useContext } from "react";

export interface MmEmarsysConfig {
  language: string;
  country: string;
  optinMethod: string;
}

const MmEmarsysConfigContext = createContext<MmEmarsysConfig | undefined>(
  undefined,
);

export type MmEmarsysConfigProviderProps = PropsWithChildren<MmEmarsysConfig>;

export const MmEmarsysConfigProvider = (
  props: MmEmarsysConfigProviderProps,
) => {
  const { children, ...config } = props;

  return (
    <MmEmarsysConfigContext.Provider value={config}>
      {children}
    </MmEmarsysConfigContext.Provider>
  );
};

export const useMmEmarsysConfig = () => {
  const config = useContext(MmEmarsysConfigContext);
  if (!config) {
    throw new Error(
      "useMmEmarsysConfig must be used within MmEmarsysConfigProvider",
    );
  }
  return config;
};
